const Options={
    // 城市
    cityOptions: [
        {
          value: "上海",
          label: "上海",
          children:[
            {
              value: "上海市",
              label: "上海市",
            }
          ]
        },
        {
          value: "江苏省",
          label: "江苏省",
          children: [
            {
              value: "南京市",
              label: "南京市",
            },
            {
              value: "无锡市",
              label: "无锡市",
            },
            {
              value: "徐州市",
              label: "徐州市",
            },
            {
              value: "常州市",
              label: "常州市",
            },
            {
              value: "苏州市",
              label: "苏州市",
            },
            {
              value: "南通市",
              label: "南通市",
            },
            {
              value: "连云港市",
              label: "连云港市",
            },
            {
              value: "淮安市",
              label: "淮安市",
            },
            {
              value: "盐城市",
              label: "盐城市",
            },
            {
              value: "扬州市",
              label: "扬州市",
            },
            {
              value: "镇江市",
              label: "镇江市",
            },
            {
              value: "泰州市",
              label: "泰州市",
            },
            {
              value: "宿迁市",
              label: "宿迁市",
            },
          ],
        },
        {
          value: "浙江省",
          label: "浙江省",
          children: [
            {
              value: "杭州市",
              label: "杭州市",
            },
            {
              value: "宁波市",
              label: "宁波市",
            },
            {
              value: "温州市",
              label: "温州市",
            },
            {
              value: "绍兴市",
              label: "绍兴市",
            },
            {
              value: "湖州市",
              label: "湖州市",
            },
            {
              value: "嘉兴市",
              label: "嘉兴市",
            },
            {
              value: "金华市",
              label: "金华市",
            },
            {
              value: "衢州市",
              label: "衢州市",
            },
            {
              value: "舟山市",
              label: "舟山市",
            },
            {
              value: "台州市",
              label: "台州市",
            },
            {
              value: "丽水市",
              label: "丽水市",
            },
          ],
        },
        {
          value: "安徽省",
          label: "安徽省",
          children: [
            {
              value: "合肥市",
              label: "合肥市",
            },
            {
              value: "芜湖市",
              label: "芜湖市",
            },
            {
              value: "马鞍山市",
              label: "马鞍山市",
            },
            {
              value: "铜陵市",
              label: "铜陵市",
            },
            {
              value: "池州市",
              label: "池州市",
            },
            {
              value: "安庆市",
              label: "安庆市",
            },
            {
              value: "宣城市",
              label: "宣城市",
            },
            {
              value: "滁州市",
              label: "滁州市",
            },
            {
              value: "淮北市",
              label: "淮北市",
            },
            {
              value: "蚌埠市",
              label: "蚌埠市",
            },
            {
              value: "淮南市",
              label: "淮南市",
            },
            {
              value: "宿州市",
              label: "宿州市",
            },
            {
              value: "阜阳市",
              label: "阜阳市",
            },
            {
              value: "亳州市",
              label: "亳州市",
            },
            {
              value: "六安市",
              label: "六安市",
            },
            {
              value: "黄山市",
              label: "黄山市",
            },
          ],
        },
      ],
    //   综合经济
    zbOptions: [
      
        {
          value: "经济发展",
          label: "经济发展",
          children:[
            {
                value: "GDP(亿元)",
                label: "GDP(亿元)",
            },
            {
                value: "人均GDP(元)",
                label: "人均GDP(元)",
            },
            {
                value: "第一产业总产值(亿元)",
                label: "第一产业总产值(亿元)",
            },
            {
                value: "第二产业总产值(亿元)",
                label: "第二产业总产值(亿元)",
            },
            {
                value: "第三产业总产值(亿元)",
                label: "第三产业总产值(亿元)",
            },
            {
                value: "种植业产值（亿元）",
                label: "种植业产值（亿元）",
            },
            {
                value: "林业产值（亿元）",
                label: "林业产值（亿元）",
            },
            {
                value: "牧业产值（亿元）",
                label: "牧业产值（亿元）",
            },
            {
                value: "渔业产值（亿元）",
                label: "渔业产值（亿元）",
            },
       
          ]
        },
        {
          value: "工业",
          label: "工业",
          children:[
            {
                value: "规模以上工业总产值(万元)",
                label: "规模以上工业总产值(万元)",
            },
            {
                value: "轻工业（亿元）",
                label: "轻工业（亿元）",
            },
            {
                value: "重工业（亿元）",
                label: "重工业（亿元）",
            },
            {
                value: "煤炭采选业（万元）",
                label: "煤炭采选业（万元）",
            },
            {
                value: "石油和天然气开采业（万元）",
                label: "石油和天然气开采业（万元）",
            },
            {
                value: "非金属矿采选业（万元）",
                label: "非金属矿采选业（万元）",
            },
            {
                value: "农副食品加工业（万元）",
                label: "农副食品加工业（万元）",
            },
            {
                value: "食品制造业（万元）",
                label: "食品制造业（万元）",
            },
            {
                value: "饮料制造业（万元）",
                label: "饮料制造业（万元）",
            },
            {
                value: "纺织业（万元）",
                label: "纺织业（万元）",
            },
            {
                value: "服装及其他纤维制品制造业（万元）",
                label: "服装及其他纤维制品制造业（万元）",
            },
            {
                value: "皮革、毛皮、羽绒及其制品业（万元）",
                label: "皮革、毛皮、羽绒及其制品业（万元）",
            },
            {
                value: "木材加工及竹、藤、棕、草制品业（万元）",
                label: "木材加工及竹、藤、棕、草制品业（万元）",
            },
            {
                value: "家具制造业（万元）",
                label: "家具制造业（万元）",
            },
            {
                value: "造纸及纸制品业（万元）",
                label: "造纸及纸制品业（万元）",
            },
            {
                value: "印刷业、记录媒介的复制（万元）",
                label: "印刷业、记录媒介的复制（万元）",
            },
            {
                value: "文教体育用品制造业（万元）",
                label: "文教体育用品制造业（万元）",
            },
            {
                value: "石油加工及炼焦业（万元）",
                label: "石油加工及炼焦业（万元）",
            },
            {
                value: "化学原料及化学制品制造业（万元）",
                label: "化学原料及化学制品制造业（万元）",
            },
            {
                value: "医药制造业（万元）",
                label: "医药制造业（万元）",
            },
            {
                value: "化学纤维制造业（万元）",
                label: "化学纤维制造业（万元）",
            },
            {
                value: "橡胶和塑料制品业（万元）",
                label: "橡胶和塑料制品业（万元）",
            },
            {
                value: "非金属矿物制品业（万元）",
                label: "非金属矿物制品业（万元）",
            },
            {
                value: "黑色金属冶炼及压延加工业（万元）",
                label: "黑色金属冶炼及压延加工业（万元）",
            },
            {
                value: "有色金属冶炼及压延加工业（万元）",
                label: "有色金属冶炼及压延加工业（万元）",
            },
            {
                value: "金属制品业（万元）",
                label: "金属制品业（万元）",
            },
            {
                value: "普通机械制造业（万元）",
                label: "普通机械制造业（万元）",
            },
            {
                value: "专用设备制造业（万元）",
                label: "专用设备制造业（万元）",
            },
            {
                value: "电气机械及器材制造业（万元）",
                label: "电气机械及器材制造业（万元）",
            },
            {
                value: "电子及通信设备制造业（万元）",
                label: "电子及通信设备制造业（万元）",
            },
            {
                value: "仪器仪表及文化、办公用机械制造业（万元）",
                label: "仪器仪表及文化、办公用机械制造业（万元）",
            },
            {
                value: "其他制造业（万元）",
                label: "其他制造业（万元）",
            },
            {
                value: "  电力、燃气、水的生产和供应业（万元）",
                label: "  电力、燃气、水的生产和供应业（万元）",
            },
          ]
        },
        {
          value: "农业",
          label: "农业",
          children:[
            {
                value: "农业机械总动力（千瓦）",
                label: "农业机械总动力（千瓦）",
            },
            {
                value: "猪出栏数量(万头)",
                label: "猪出栏数量(万头)",
            },
            {
                value: "牛出栏数量(头)",
                label: "牛出栏数量(头)",
            },
            {
                value: "羊出栏数量(万只)",
                label: "羊出栏数量(万只)",
            },
            {
                value: "家禽出栏量(万只)",
                label: "家禽出栏量(万只)",
            },
            {
                value: "农用化肥施用折纯量(吨)",
                label: "农用化肥施用折纯量(吨)",
            },
            {
                value: "农用氮肥施用折纯量(吨)",
                label: "农用氮肥施用折纯量(吨)",
            },
            {
                value: "农用磷肥施用折纯量(吨)",
                label: "农用磷肥施用折纯量(吨)",
            },
            {
                value: "农用钾肥施用折纯量(吨)",
                label: "农用钾肥施用折纯量(吨)",
            },
            {
                value: "农用复合肥施用折纯量(吨)",
                label: "农用复合肥施用折纯量(吨)",
            },
            {
                value: "农药使用量(吨)",
                label: "农药使用量(吨)",
            },
          ]
        },
        {
          value: "建筑业",
          label: "建筑业",
          children:[
            {
                value: "建筑业总产值（亿元）",
                label: "建筑业总产值（亿元）",
            },
            {
                value: "建筑施工企业竣工产值（亿元）",
                label: "建筑施工企业竣工产值（亿元）",
            },
            {
                value: "建筑施工企业建筑面积（平方千米）",
                label: "建筑施工企业建筑面积（平方千米）",
            },
          ]
        },
        {
          value: "交通运输",
          label: "交通运输",
          children:[
            {
                value: "客运量(万人次)",
                label: "客运量(万人次)",
            },
            {
                value: "铁路客运量(万人)",
                label: "铁路客运量(万人)",
            },
            {
                value: "公路客运量(万人)",
                label: "公路客运量(万人)",
            },
            {
                value: "水运客运量(万人)",
                label: "水运客运量(万人)",
            },
            {
                value: "货运量(万吨)",
                label: "货运量(万吨)",
            },
            {
                value: "铁路货运量(万吨)",
                label: "铁路货运量(万吨)",
            },
            {
                value: "公路货运量(万吨)",
                label: "公路货运量(万吨)",
            },
            {
                value: "水运货运量(万吨)",
                label: "水运货运量(万吨)",
            },
            {
                value: "民用车拥有量（辆）",
                label: "民用车拥有量（辆）",
            },
          ]
        },
        {
          value: "气候",
          label: "气候",
          children:[
            {
                value:"气温（℃）",
                label:"气温（℃）"
            },
            {
                value:"降水总量（mm）",
                label:"降水总量（mm）"
            },
          ]
        },
      ],
      // 污染物
    wrwOptions:[
      {
        value: "重金属污染物",
        label: "重金属污染物",
        children:[
          {
            label:'Cd(mg/kg)',
            value:'Cd(mg/kg)'
          },
          {
            label:'Pb(mg/kg)',
            value:'Pb(mg/kg)'
          },
          {
            label:'Cu(mg/kg)',
            value:'Cu(mg/kg)'
          },
          {
            label:'Zn(mg/kg)',
            value:'Zn(mg/kg)'
          },
          {
            label:'Ni(mg/kg)',
            value:'Ni(mg/kg)' 
          },
          {
            label:'Cr(mg/kg)',
            value:'Cr(mg/kg)'
          },
          {
            label:'As(mg/kg)',
            value:'As(mg/kg)'
          },
          {
            label:'Hg(mg/kg)',
            value:'Hg(mg/kg)'
          },
          // {
          //   label:'∑HM(mg/kg)',
          //   value:'∑HM(mg/kg)'
          // },
        ]
      },
      {
        value: "多环芳烃污染物",
        label: "多环芳烃污染物",
        children:[
          {
            value:"Nap(μg/kg)",
            label:"Nap(μg/kg)"
          },
          {
            value:"Acy(μg/kg)",
            label:"Acy(μg/kg)"
          },
          {
            value:"Ace(μg/kg)",
            label:"Ace(μg/kg)"
          },
          {
            value:"Flu(μg/kg)",
            label:"Flu(μg/kg)"
          },
          {
            value:"Phe(μg/kg)",
            label:"Phe(μg/kg)"
          },
          {
            value:"Ant(μg/kg)",
            label:"Ant(μg/kg)"
          },
          {
            value:"Fla(μg/kg)",
            label:"Fla(μg/kg)"
          },
          {
            value:"Pyr(μg/kg)",
            label:"Pyr(μg/kg)"
          },
          {
            value:"BaA(μg/kg)",
            label:"BaA(μg/kg)"
          },
          {
            value:"Chr(μg/kg)",
            label:"Chr(μg/kg)"
          },
          {
            value:"BbF(μg/kg)",
            label:"BbF(μg/kg)"
          },
          {
            value:"BkF(μg/kg)",
            label:"BkF(μg/kg)"
          },
          {
            value:"BaP(μg/kg)",
            label:"BaP(μg/kg)"
          },
          {
            value:"DahA(μg/kg)",
            label:"DahA(μg/kg)"
          },
          {
            value:"BghiP(μg/kg)",
            label:"BghiP(μg/kg)"
          },
          {
            value:"InP(μg/kg)",
            label:"InP(μg/kg)"
          },
          {
            value:"LMW PAHs(μg/kg)",
            label:"LMW PAHs(μg/kg)"
          },
          {
            value:"MMW PAHs(μg/kg)",
            label:"MMW PAHs(μg/kg)"
          },
          {
            value:"HMW PAHs(μg/kg)",
            label:"HMW PAHs(μg/kg)"
          },
          {
            value:"Σ16PAHs(μg/kg)",
            label:"Σ16PAHs(μg/kg)"
          },
        ]
      }
     
    ],
    wrwOptions1:[
      {
        value: "重金属污染物",
        label: "重金属污染物",
        children:[
          {
            label:'Cd(mg/kg)',
            value:'Cd(mg/kg)'
          },
          {
            label:'Pb(mg/kg)',
            value:'Pb(mg/kg)'
          },
          {
            label:'Cu(mg/kg)',
            value:'Cu(mg/kg)'
          },
          {
            label:'Zn(mg/kg)',
            value:'Zn(mg/kg)'
          },
          {
            label:'Ni(mg/kg)',
            value:'Ni(mg/kg)' 
          },
          {
            label:'Cr(mg/kg)',
            value:'Cr(mg/kg)'
          },
          {
            label:'As(mg/kg)',
            value:'As(mg/kg)'
          },
          {
            label:'Hg(mg/kg)',
            value:'Hg(mg/kg)'
          },
          // {
          //   label:'∑HM(mg/kg)',
          //   value:'∑HM(mg/kg)'
          // },
        ]
      },
      {
        value: "多环芳烃污染物",
        label: "多环芳烃污染物",
        children:[
          {
            value:"Σ16PAHs(μg/kg)",
            label:"Σ16PAHs(μg/kg)"
          },
        ]
      }
     
    ],
    risksOptions:[
      {
        label:"致癌",
        value:"致癌"
      },
      {
        label:"非致癌",
        value:"非致癌"
      },
    ],
    ageOptions:[
      {
        label:"儿童",
        value:false
      },
      {
        label:"成人",
        value:true
      },
    ],
    wrwSx:{
      Cd:0.4,
      Pb:100,
      Cu:50,
      Zn:200,
      Ni:70,
      Cr:250,
      As:30,
      Hg:0.5,
      BaP:0.55,
      
    },
    wrwGz:{
      Cd:2.0,
      Pb:400,
      Cu:null,
      Zn:null,
      Ni:null,
      Cr:800,
      As:150,
      Hg:2.5      ,
      BaP:null,
    }
      
    
}
export default Options